.LegendBlock {
  border-radius: 10px;
  border: 1px solid var(--colori-neutri-white);
  background: var(--primary);
  box-shadow: -4px 4px 10px 4px rgba(0, 0, 0, 0.3);
  width: 370px;
  position: absolute;
  top: 80px;
  left: 20px;
  z-index: 9999;
  height: 460px;
  padding: 8px 16px;
  overflow-y: auto;
}

.LegendTitle {
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  color: var(--colori-neutri-white);
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 8px;
  border-bottom: 0.5px solid var(--colori-neutri-white);
}

.CardCategorie {
  border-radius: 5px;
  background: rgba(255, 255, 255, 0.9);

  box-shadow: 2px 2px 0px 0px rgba(17, 138, 178, 0.05);
  padding: 16px 16px;
  margin-top: 8px;
}

.CardColori {
  border-radius: 5px;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 2px 2px 0px 0px rgba(17, 138, 178, 0.05);
  padding: 16px 16px;
  margin-top: 8px;
}

.TitleCategorie {
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  color: var(--primary);
}

.DescCategorie {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  color: var(--colori-neutri-gray);
  margin-top: 8px;
  margin-bottom: 8px;
}


.ItemCard {
  margin-bottom: 8px;
  color: var(--primary);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  font-family: var(--font-roboto-slab);
  display: flex;
  align-items: center;
}

.NameItem {
  margin-left: 8px;
}

.CardConcorso{
  border-radius: 5px;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 2px 2px 0px 0px rgba(17, 138, 178, 0.05);
  padding: 16px 16px;
  margin-top: 8px;
}